import React, { useState } from 'react'
import { HorizontalStack, ShowOnlyOnScreenSize } from '@ztechapps/webui.util'
import { Navbar, Offcanvas, Nav } from 'react-bootstrap'
import { BusyButton } from '@ztechapps/webui.button'
import { usePageLifecycle } from '@ztechapps/common.hook'
import { Link, useLocation } from 'react-router-dom'
import { routesDef } from '../../config/routes'
import Profile from './profile'

const MOBILE_BREAKING_POINT = 992

export default function Header() {
  return (
    <Navbar className="header" expand="lg" fixed="top" bg="dark" variant="dark">
      <Navbar.Brand as={Link} to={routesDef.DashboardPage.path} className="ms-3">
        <span className="fw-bold text-success">OwnText</span>
        <span className="text-muted ms-2 small">Admin</span>
      </Navbar.Brand>

      <ShowOnlyOnScreenSize size={'desktop'} breakingPoint={MOBILE_BREAKING_POINT}>
        <TopBarContent />
      </ShowOnlyOnScreenSize>

      <ShowOnlyOnScreenSize size={'mobile'} breakingPoint={MOBILE_BREAKING_POINT}>
        <OffCanvasMenu />
      </ShowOnlyOnScreenSize>
    </Navbar>
  )
}

const OffCanvasMenu = () => {
  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  usePageLifecycle(null, handleClose)

  return (
    <div className="me-2">
      <BusyButton icon="bars" onClick={handleShow} variant="outline-light" />

      <Offcanvas show={show} onHide={handleClose} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <span className="fw-bold text-success">OwnText</span>
            <span className="text-muted ms-2">Admin</span>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <MenuBar vertical />
          <hr />
          <Profile />
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  )
}

const TopBarContent = () => {
  return (
    <>
      <MenuBar />
      <nav className="ms-auto me-3">
        <HorizontalStack gap={2} className="align-items-center">
          <Profile />
        </HorizontalStack>
      </nav>
    </>
  )
}

const MenuBar = ({ vertical = false }: { vertical?: boolean }) => {
  const location = useLocation()

  const menuItems = [
    { name: 'Dashboard', path: routesDef.DashboardPage.path, icon: 'chart-line' },
    { name: 'Inbox', path: routesDef.InboxPage.path, icon: 'inbox' },
    { name: 'Outbox', path: routesDef.OutboxPage.path, icon: 'paper-plane' },
    { name: 'Settings', path: routesDef.SettingsPage.path, icon: 'cog' },
  ]

  const isActive = (path: string) => location.pathname.startsWith(path)

  return (
    <Nav className={vertical ? 'flex-column' : ''}>
      {menuItems.map((item) => (
        <Nav.Link key={item.path} as={Link} to={item.path} className={isActive(item.path) ? 'active fw-bold' : ''}>
          {item.name}
        </Nav.Link>
      ))}
    </Nav>
  )
}
